import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

export const Footer = () => {
  return (
    <footer className="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-2">
            <h3 className="text-2xl font-heading font-bold mb-4">
              Tango<span className="text-primary">Flow</span>
            </h3>
            <p className="text-muted-foreground text-sm leading-relaxed max-w-md">
              Entdecken Sie die Leidenschaft des Tango Argentino. 
              Professionelle Kurse für Anfänger bis Fortgeschrittene in einer 
              einzigartigen Atmosphäre.
            </p>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Navigation
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/courses" className="text-sm text-foreground/70 hover:text-foreground transition-colors">
                  Kurse
                </Link>
              </li>
              <li>
                <Link to="/partner-search" className="text-sm text-foreground/70 hover:text-foreground transition-colors">
                  Tanzpartnerbörse
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-sm text-foreground/70 hover:text-foreground transition-colors">
                  Registrieren
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-widest text-muted-foreground mb-4">
              Kontakt
            </h4>
            <ul className="space-y-2 text-sm text-foreground/70">
              <li>info@tangoflow.de</li>
              <li>+49 123 456 789</li>
              <li>Tangostraße 42</li>
              <li>10115 Berlin</li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-border mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-muted-foreground">
            © 2025 TangoFlow. Alle Rechte vorbehalten.
          </p>
          <p className="text-sm text-muted-foreground flex items-center gap-1">
            Mit <Heart className="w-4 h-4 text-primary fill-primary" /> für Tango gemacht
          </p>
        </div>
      </div>
    </footer>
  );
};
